import { observable, computed, action, makeObservable } from "mobx";

class DeliveryStore {

    constructor() {
        makeObservable(this);
    }

    /**
     * 배달요청탭
     * @type ext, self
     * @private
     */
    @observable
    _st_delivery_tab = "ext"


    @computed
    get getDeliveryTab() {
        return this._st_delivery_tab;
    }

    @action
    setDeliveryTab(val) {
        this._st_delivery_tab = val;
    }

    /**
     * 배달대행사 조회된 목록
     * @type {[]}
     * @private
     */
    @observable
    _st_ext_delivery = []

    @computed
    get getExpDelivery() {
        return this._st_ext_delivery;
    }

    //배달대행사 초기화
    @action
    setinitDelivery() {
        this._st_ext_delivery = []
    }

    @computed
    get getExpDeliverySelect() {
        return this._st_ext_delivery.find(data => {
            if (data.view === "on")
                return data
        })
    }

    // view : 선택 여부
    // show : 다음버튼 눌렀을경우 수겨지는 항목
    @action
    setExpDelivery(list) {
        this._st_ext_delivery = list.map((item, index) => {
            if (index === 0) {
                return { ...item, view: 'on', fee: "0", show: true };

            } else {
                return { ...item, view: 'off', fee: "0", show: true };
            }
        }
        );
    }

    @action
    setChangeDelivery(delivery_code) {
        this._st_ext_delivery = this._st_ext_delivery.map((item, index) => {
            if (item.delivery_code === delivery_code) {
                //선택 객체 상세 담기
                this.setDxtDetail(item)
                return { ...item, view: 'on' };

            } else {
                return { ...item, view: 'off' };
            }
        }
        );
    }

    @action
    setChangeShowDeliveryPrev() {

        let procBl = false;
        this._st_ext_delivery = this._st_ext_delivery.reverse().map((item, index) => {
            if (!procBl) {
                if (item.show === false) {
                    procBl = true;
                    return { ...item, show: true };
                } else {
                    return item;
                }
            } else {
                return item;
            }
        }
        ).reverse();
    }

    @action
    setChangeShowDeliveryNext() {

        let procBl = false;
        this._st_ext_delivery = this._st_ext_delivery.map((item, index) => {
            if (!procBl && (index < (this._st_ext_delivery.length - 1))) {
                if (item.show === true) {
                    procBl = true;
                    return { ...item, show: false };
                } else {
                    return item;
                }
            } else {
                return item;
            }
        }
        );
    }

    /**
     * 배달 대행사 배달비 목록
     * @type {[]}
     * @private
     */
    @observable
    _st_ext_delivery_fee = []

    @computed
    get getExpDeliveryFee() {
        return this._st_ext_delivery_fee;
    }

    @action
    setExpDeliveryFee(obj) {
        const findObj = this._st_ext_delivery_fee.find((data) => data.delivery_code === obj.delivery_code)
        if (findObj === undefined) {
            this._st_ext_delivery_fee.push(obj)
        } else {
            this._st_ext_delivery_fee = this._st_ext_delivery_fee.map(data => {
                if (data.delivery_code === obj.delivery_code) {
                    return obj;
                } else {
                    return data;
                }
            });
        }
    }

    @action
    initExpDeliveryFee() {
        this._st_ext_delivery_fee = [];
    }

    @action
    setExpDeliveryFeeSelect(obj) {
        this.setDeliveryFee(this._st_ext_delivery_fee.find((data) => data.delivery_code === obj.delivery_code))
    }


    /**
     * 선택한 배달 대행사 정보
     * @type {{}}
     * @private
     */
    @observable
    _st_ext_detail = {}

    @computed
    get getExtDetail() {
        return this._st_ext_detail;
    }

    @action
    setDxtDetail(item) {
        this._st_ext_detail = item;
    }

    @action
    setDeliveryDetailFee(fee) {
        this._st_ext_detail = { ...this._st_ext_detail, fee: fee };
    }

    @action
    setDeliveryDetailTime(time) {
        this._st_ext_detail = { ...this._st_ext_detail, delivery_time: time };
    }
    /**
     * 배달 대행사 배달비 정보
     * @type {{}}
     * @private
     */
    @observable
    _st_delivery_fee = {
        delivery_distance: "0"
        , delivery_fee: "0"
        , extra_tot: "0"
        , pick_arr: ["1", "5", "10", "15", "20", "30", "45", "60"]
        , pick_arr_obj: []
    }

    @computed
    get getDeliveryFee() {
        return this._st_delivery_fee;
    }

    @computed
    get getDeliveryDefaultFee() {
        let default_fee = this._st_delivery_fee.delivery_fee ? this._st_delivery_fee.delivery_fee : "0";
        let extra_tot = this._st_delivery_fee.extra_tot ? this._st_delivery_fee.extra_tot : "0";
        return (Number(default_fee) - Number(extra_tot)) + "";
    }

    @action
    setDeliveryFee(obj) {

        let pick_arr_obj = [];
        if (obj != undefined) {
            if (obj.pick_arr) {
                for (let pick of obj.pick_arr) {
                    let obj = { time: pick, view: false };
                    pick_arr_obj.push(obj);
                }
            }

            this._st_delivery_fee = { ...obj, pick_arr_obj: pick_arr_obj };
        }

    }

    @action
    setDeliveryListFee(dlv_code, fee, shop_cash) {
        this._st_ext_delivery = this._st_ext_delivery.map(obj => {
            if (obj.delivery_code === dlv_code) {
                return { ...obj, fee: fee, shop_cash: shop_cash };
            } else {
                return obj;
            }
        });
    }

    @action
    initDeliveryListFee() {
        this._st_ext_delivery = this._st_ext_delivery.map(obj => {
            return { ...obj, fee: "0" };
        });
    }

    @action
    initDeliveryFee() {
        this._st_delivery_fee = {};
    }

    @action
    setChangePickView(time) {
        this._st_delivery_fee.pick_arr_obj = this._st_delivery_fee.pick_arr_obj.map(pick => {
            if (pick.time === time) {
                return { ...pick, view: true }
            } else {
                return { ...pick, view: false }
            }
        });
    }

    /**
     * 배달 사원 정보
     * @type {{}}
     * @private
     */
    @observable
    _st_delivery_asp = []

    @computed
    get getDeliveryAsp() {
        return this._st_delivery_asp;
    }

    @action
    setDeliveryAsp(Arr) {
        this._st_delivery_asp = Arr;
    }

    /**
     * 배달 사원 등록,수정
     * @type {string}
     * @private
     */
    @observable
    _st_delivery_asp_form = {
        'actionFlag': 'C',
        'empNo': '',
        'empNm': '',
        'empPw': '',
        'reEmpPw': '',
        'retireFlag': '0',
        'isNameValid': null,
        'isPosPassValid': null,
        'isPosRePassValid': null
    }

    get getDeliveryAspForm() {
        return this._st_delivery_asp_form;
    }
    @action
    setDeliveryAspForm(key, value) {
        this._st_delivery_asp_form = { ...this._st_delivery_asp_form, [key]: value };
    }

    @action
    initDeliveryAspForm() {
        this._st_delivery_asp_form = {
            'actionFlag': 'C',
            'empNo': '',
            'empNm': '',
            'empPw': '',
            'reEmpPw': '',
            'retireFlag': '0',
            'isNameValid': null,
            'isPosPassValid': null,
            'isPosRePassValid': null
        }
    }

    /**
     * 자체 배달사원 선택
     * @type {{}}
     * @private
     */
    @observable
    _st_self_delivery = {}

    @computed
    get getSelfDelivery() {
        return this._st_self_delivery;
    }

    @action
    setSelfDelivery(obj) {
        this._st_self_delivery = obj;
    }

    /**
     * 배달 대행사 연동 목록
     * @type {{}}
     * @private
     */
    @observable
    _st_delivery_connect_list = []

    @computed
    get getDeliveryConnectList() {
        return this._st_delivery_connect_list;
    }

    @action
    setDeliveryConnectList(Arr) {
        this._st_delivery_connect_list = Arr;
    }


    //배달대행사 연동 클릭
    @observable
    _st_dlv_connect_code = [];

    get getDlvConnectCode() {
        return this._st_dlv_connect_code;
    }

    @action
    setDlvConnectCode(code) {
        this._st_dlv_connect_code = code;
    }

    // 배달대행사 연동 가게 리스트
    @observable
    _st_dlv_connect_shop_list = [];
    get getDlvConnectShopList() {
        return this._st_dlv_connect_shop_list;
    }
    @action
    setDlvConnectShopList(list) {
        this._st_dlv_connect_shop_list = list;
    }
}

export default new DeliveryStore();